import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { getInvitePropertyPerUserAction } from 'store/actions/inviteActions';
import { useStableKey } from './useStableKey';

/**
 * Loads invite-property list for a delegation user.
 * Pass pagination/sortOptions on edit screens that paginate "my properties".
 */
export function useInvitePropertyPerUserFetch(
  delegation,
  {
    enabled = true,
    pagination = null,
    sortOptions = null,
    filter = null,
    selectedBType = [],
    isSHouse = [],
  } = {},
) {
  const dispatch = useDispatch();
  const sortKey = useStableKey(sortOptions);
  const selectedBTypeKey = useStableKey(selectedBType);
  const isSHouseKey = useStableKey(isSHouse);

  useEffect(() => {
    if (!enabled || !delegation) return;

    dispatch(
      getInvitePropertyPerUserAction({
        accepter_id: delegation.accepter_id,
        accepter_role: delegation.accepter_role,
        requestor_id: delegation.requestor_id,
        requestor_role: delegation.requestor_role,
        landlord_id: delegation.landlord_id,
        ...(pagination
          ? {
              offset: pagination.pageNumber * pagination.rowsPerPage,
              limit: pagination.rowsPerPage,
            }
          : {}),
        ...(sortOptions ? { sortOptions } : {}),
        ...(filter ? { filter } : {}),
        selectedBType,
        isSHouse,
      }),
    );
  }, [
    enabled,
    dispatch,
    delegation?.accepter_id,
    delegation?.accepter_role,
    delegation?.requestor_id,
    delegation?.requestor_role,
    delegation?.landlord_id,
    pagination?.pageNumber,
    pagination?.rowsPerPage,
    sortKey,
    filter?.searchText,
    selectedBTypeKey,
    isSHouseKey,
  ]);
}
